import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center w-full" }
const _hoisted_2 = { class: "flex flex-col gap-y-[3px] p-[10px] text-center" }
const _hoisted_3 = { class: "flex flex-col gap-y-[3px] p-[10px] text-center" }
const _hoisted_4 = { class: "flex flex-col gap-y-[3px] p-[10px] text-center" }

import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseLine from '@/components/common/BaseLine.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'FourthSection',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseTypography, {
        text: _unref(t)('main-page.fourth-section.first'),
        type: "title-m"
      }, null, 8, ["text"]),
      _createVNode(BaseLine, { width: "156" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(BaseTypography, {
        text: _unref(t)('main-page.fourth-section.second'),
        type: "title-m"
      }, null, 8, ["text"]),
      _createVNode(BaseLine, { width: "220" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(BaseTypography, {
        text: _unref(t)('main-page.fourth-section.third'),
        type: "title-m"
      }, null, 8, ["text"]),
      _createVNode(BaseLine, { width: "291" })
    ])
  ]))
}
}

})